import React, { useContext, useEffect, useState } from 'react'
import studyReportContext from '../../../../context/studyreport/StudyReportContext';
import { useTranslation } from 'react-i18next';
import ManageClippedKeyImagePreview from './ManageClippedKeyImagePreview';
import { Checkbox, Icon, TextField, TooltipHost } from '@fluentui/react';
import Save from '../../../../components/SVGComponents/KeyImage/Save';
import Revert from '../../../../components/SVGComponents/KeyImage/Revert';
import Clear from '../../../../components/SVGComponents/KeyImage/Clear';
import Edit from '../../../../components/SVGComponents/KeyImage/Edit';
import { useFormik } from 'formik';
import { KeyImageSchema } from '../../../../Schemas/KeyImageSchema';
import ATextField from '../../../../components/ATextField';
import { _getCLippedKeyImageForPreview } from '../../../../service/StudyViewerService';
import { AdvKeyImageSchema } from '../../../../Schemas/AdvKeyImageSchema';
import { USERTYPES } from '../../../../constants/Constants';
import CustomToolTipHost from '../../../../components/CustomToolTipHost/CustomToolTipHost';

const ClippedKeyImageRow = (props) => {

    const [isEditable, setIsEditable] = useState(false);
    const [previewClippedKeyImage, setPreviewClippedKeyImage] = useState(false);
    const [previewClippedKeyImageId, setPreviewClippedKeyImageId ] = useState("");

    let clippedKeyImageData = props.clippedKeyImagesData;

    const {
        setAlertSuccessModal,
        alertSuccessModal, setPreviewClippedKeyImageBase64, previewClippedKeyImageBase64, maskedImageEnabledLimit
      } = useContext(studyReportContext);

    const keyImage = props.keyImage;
    const imageTitle = keyImage.title;
    const { t } = useTranslation();

    useEffect(()=>{
        clippedKeyImageData = [];
        for(let index in props.clippedKeyImagesData){
            let obj = {...props.clippedKeyImagesData[index]};
            clippedKeyImageData.push(obj);
        }
        console.log("templist---clippedKeyImageData---", clippedKeyImageData);
    },[props.clippedKeyImagesData]);

    const {
        values,
        errors,
        touched,
        handleBlur,
        handleChange,
        handleSubmit,
        resetForm,
      } = useFormik({
        enableReinitialize: true,
        initialValues: { imageTitle },
        validationSchema: AdvKeyImageSchema,
        onSubmit: async (values, action) => {
            if (isKeyImageTitleAlreadyPresent(values.imageTitle)) {
                console.log("is key submitted")
                setAlertSuccessModal(()=>{
                const newItem = {...alertSuccessModal};
                newItem.show = true;
                newItem.heading = "Alert";
                newItem.isError = false;
                newItem.isSuccess = false;
                newItem.isWarning = true;
                newItem.description = t("clipped-key-images.title-already-exists");
                return newItem;
                });
                action.resetForm();
                return;
            }
            console.log(props.index, clippedKeyImageData);
            clippedKeyImageData[props.index].title=values.imageTitle;
            props.setClippedKeyImagesData(clippedKeyImageData);
            setIsEditable(false);
            action.resetForm();
        },
    });

    const handleSaveTool = () =>{
        handleSubmit();
    }

    const handleResetTool = () =>{
        resetForm();
    }

    const handleClearTool = () =>{
        setIsEditable(false);
    }

    const handleClippedKeyImageCheckBox = (imageId, index, event) =>{
        // event.preventDefault();
        let isChecked = event.target.checked;
        let countSelected = props.clippedKeyImagesData.filter((e)=> e.enabled===true).length;
        console.log("countSelected--",countSelected);
        if(isChecked && countSelected >= maskedImageEnabledLimit){
          setAlertSuccessModal(() => {
              const newItem = { ...alertSuccessModal };
              newItem.show = true;
              newItem.heading = "Alert";
              newItem.isError = true;
              newItem.isSuccess = false;
              newItem.isWarning = true;
              newItem.description = "A maximum of " + maskedImageEnabledLimit + " masked images can be selected.";
              return newItem;
            });
            console.log("alert done", props.advKeyImagesData);
            return;
      }
     
            let tempList = [];
            console.log("clippedKeyImagesData-----",props.clippedKeyImagesData);
            for(let index in props.clippedKeyImagesData){
                let keyimage = props.clippedKeyImagesData[index];
                let obj  = {...keyimage};
                tempList.push(obj);
            }
            console.log("templist after operation on checkbox--",tempList);
            tempList[index].enabled=isChecked;
            props.setClippedKeyImagesData(tempList);
    }

    const isKeyImageTitleAlreadyPresent = (keyTitle) => {
        for(let index in clippedKeyImageData){
            if (index != props.index && clippedKeyImageData[index].title === keyTitle) {
                return true;
            }
        }
        return false;
    };


  return (
    <>
        {previewClippedKeyImage && 
        <ManageClippedKeyImagePreview
            previewClippedKeyImage={previewClippedKeyImage}
            setPreviewClippedKeyImage={setPreviewClippedKeyImage}
            studyId={props.studyId}
            imageId={previewClippedKeyImageId}
            previewClippedKeyImageBase64={previewClippedKeyImageBase64}
        />
        }
            <div id={keyImage.imageId}
                style={{
                width: "97%",
                display: "flex",
                alignItems: "center",
              //  backgroundColor: "#262525",
                borderRadius: "10px",
                // height: "60px",
              //  marginTop: "10px",
                cursor:"pointer"
                }}
            >   
               {/*
                <div
                style={{ width: "10%", paddingRight:"10px", display: "flex" }}
                ><CustomToolTipHost
                        content={t("clipped-key-images.key-image-enabled")}
                        id="key-images"
                     >
                    <Checkbox
                        style={{
                        fontWeight: "400",
                        paddingLeft:"5px"
                        }}
                        checked={props.keyImage.enabled}
                        onChange={(e)=>handleClippedKeyImageCheckBox(keyImage.imageId, props.index, e)}
                        boxSide="start"
                        inputProps={{ 'aria-label': 'controlled' }}
                        disabled={props.roles.length > 0 && !(props.roles[0].includes(USERTYPES.SUPERVISOR) || props.roles[0].includes(USERTYPES.RADIOLOGIST))}
                    />
                    </CustomToolTipHost>
                </div>
                
                <div id={keyImage.imageId + "_title"} style={{ width: "60%",display:"flex" }}>
                {isEditable ? (
                    <>
                    <div style={{ width: "80%", marginLeft: "10px" }}>
                    <CustomToolTipHost
                        content={t("clipped-key-images.image-title")}
                        id="key-images"
                     >
                        <ATextField
                            name="imageTitle"
                            onChange={handleChange}
                            value={values.imageTitle}
                            onBlur={handleBlur}
                            errorMessage={touched.imageTitle && errors.imageTitle}
                        />
                        </CustomToolTipHost>
                    </div>
                    </>
                ) : (<CustomToolTipHost
                        content={t("clipped-key-images.image-title")}
                        id="key-images"
                     >
                        <span style={{ color: "#FFFFFF",display:"flex" }}>
                        {t("clipped-key-images.image-title-prefix")+keyImage?.title}
                        </span>
                    </CustomToolTipHost>
                )}
                </div>
                <div style={{ width: "25%", display: "flex", alignItems: "center" }} key={props.index}>
                
                </div> */}
                <div
  style={{ width: "100%", display: "flex", position: "relative", cursor: "pointer" }}
  onClick={() => {
    setPreviewClippedKeyImageBase64(keyImage.imageURL);
    setPreviewClippedKeyImage(true);
  }}
  onMouseEnter={() => setPreviewClippedKeyImageBase64(keyImage.imageURL)}
  onMouseLeave={() => {}}
>
  {/* Checkbox overlay */}
  <div
    style={{
      position: "absolute",
      borderRadius: 4,
      bottom: "0px",        // Distance from bottom
      right: "-2px",
      display: "flex",
      alignItems: "center",
      zIndex: 1,
      padding:"2px"
    }}
    onClick={(e) => e.stopPropagation()} // Prevents triggering image click
  >
    <span style={{ fontSize: 12 }}>{t("clipped-key-images.image-title-prefix")+keyImage?.title}</span>
    <input type="checkbox"
    checked={props.keyImage.enabled}
    onChange={(e)=>handleClippedKeyImageCheckBox(keyImage.imageId, props.index, e)}
    style={{ }} />
  </div>

  {/* Image with tooltip */}
  <CustomToolTipHost
    content={t("clipped-key-images.preview-key-image")}
    id="key-images"
  >
    <img
      src={"data:image/jpeg;base64," + keyImage.imageURL}
      alt="Thumbnail"
      style={{
        width: "100%",
        height: "auto",
        objectFit: "cover",
       // borderRadius: 4,
        paddingBottom:"5px",
        display: "block"
      }}
    />
  </CustomToolTipHost>
</div>

                
            </div>
        </>
  )
}

export default ClippedKeyImageRow